import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://danni.narodnichitalishta.bg/api';

export const chitalishteApi = createApi({
  reducerPath: 'chitalishteApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ['Chitalishta'],
  endpoints: (builder) => ({
    importExcel: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: '/chitalishta/import',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Chitalishta'],
    }),
    
    getChitalishteStatus: builder.query({
      query: () => '/chitalishta/status',
    }),
    
    getChitalishteData: builder.query({
      query: ({ municipalityId, year }) => ({
        url: '/chitalishta',
        params: { municipalityId, year },
      }),
      providesTags: ['Chitalishta'],
    }),
    
    updateChitalishte: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/chitalishta/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Chitalishta'],
    }),
    
    getChitalishteStatistics: builder.query({
      query: () => '/chitalishta/statistics',
    }),
  }),
});

export const {
  useImportExcelMutation,
  useGetChitalishteStatusQuery,
  useGetChitalishteDataQuery,
  useUpdateChitalishteMutation,
  useGetChitalishteStatisticsQuery,
} = chitalishteApi;